export default __webpack_public_path__ + "01da8a133c340ecb04388c6f13804bb6.png";